/**
 * La barra del «video» de la obra: reproducir/pausar, deslizador de fecha, fecha y velocidad. La comparten el diálogo de
 * staff y la página pública del cliente (ahí `compacta` oculta la velocidad en pantallas chicas).
 */
import { Button, Select, Slider } from '@fluentui/react-components';
import { Pause20Filled, Play20Filled } from '@fluentui/react-icons';
import {
  SEGUNDOS_DEL_VIDEO,
  etiquetaDeDia,
  type VelocidadDelVideo,
} from '../../lib/avanceObra4d.js';
import type { RangoDeFechas } from './useReproduccionDeAvance.js';

interface Props {
  rango: RangoDeFechas;
  t: number;
  reproduciendo: boolean;
  velocidad: VelocidadDelVideo;
  deshabilitado?: boolean;
  /** Oculta el selector de velocidad (pantallas chicas). */
  sinVelocidad?: boolean;
  onAlternar: () => void;
  onElegirFecha: (v: number) => void;
  onVelocidad: (v: VelocidadDelVideo) => void;
}

export function BarraDeReproduccion({
  rango,
  t,
  reproduciendo,
  velocidad,
  deshabilitado,
  sinVelocidad,
  onAlternar,
  onElegirFecha,
  onVelocidad,
}: Props) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
      <Button
        appearance="primary"
        icon={reproduciendo ? <Pause20Filled /> : <Play20Filled />}
        onClick={onAlternar}
        disabled={deshabilitado}
      >
        {reproduciendo ? 'Pausar' : 'Reproducir'}
      </Button>
      <Slider
        style={{ flex: 1, minWidth: 140 }}
        min={rango.desde}
        max={rango.hasta}
        step={1}
        value={t}
        onChange={(_, d) => onElegirFecha(d.value)}
        aria-label="Fecha de la obra"
      />
      <div style={{ minWidth: 110, textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}>{etiquetaDeDia(t)}</div>
      {!sinVelocidad && (
        <Select
          aria-label="Velocidad"
          value={velocidad}
          onChange={(_, d) => onVelocidad(d.value as VelocidadDelVideo)}
          style={{ minWidth: 150 }}
        >
          {(Object.keys(SEGUNDOS_DEL_VIDEO) as VelocidadDelVideo[]).map((k) => (
            <option key={k} value={k}>
              {k === 'lenta' ? 'Lenta' : k === 'normal' ? 'Normal' : 'Rápida'} · {SEGUNDOS_DEL_VIDEO[k]} s
            </option>
          ))}
        </Select>
      )}
    </div>
  );
}
